import { Component } from '@angular/core';

import { OnInit } from '@angular/core';

import clonedeep from "lodash.clonedeep";
import { FieldGeneratorService } from '../../services/field-generator.service';
import { MatDialog } from '@angular/material';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { EventBusService } from 'src/services/event-bus.service';
import { MiscService } from 'src/services/misc.service';
import { AddManufacturerDialogComponent } from './add-organisation/add-organisation.component';
import { ConfirmationDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { MessageService } from 'src/services/message.service';

@Component({
    selector: 'rm-manage-manufacturer',
    templateUrl: './manage-organisation.component.html',
    styleUrls: ['./manage-organisation.component.css']
})
export class ManageManufacturerComponent implements OnInit {

    data: any[] = [];
    columns: any[] = [
        { name: 'gcp', displayName: 'GCP' },
        { name: 'legalName', displayName: 'Name' },
        { name: 'type', displayName: 'Type' },
        { name: 'contact.name', displayName: 'Contact Person' },
        { name: 'contact.email', displayName: 'Email' },
        { name: 'contact.mobile', displayName: 'Mobile No' },
        { name: 'address', displayName: 'Address' },
        { name: 'actions', displayName: 'Actions', type: 'actions' }
    ];
    gcp: any;

    constructor(
        private dialog: MatDialog,
        private fgService: FieldGeneratorService,
        private globalCfgService: GlobalCfgService,
        private ebService: EventBusService,
        private miscService: MiscService,
        private msgService: MessageService
    ) { }

    ngOnInit() {
        this.gcp = this.globalCfgService.getGcp();
        this.loadOrganisations();
    }

    loadOrganisations() {

        this.miscService.getOrganisations().subscribe(
            (response: any[]) => {
                console.log("response", response);

                response['data'].forEach(item => {
                    item.contact['name'] = item.contact.firstName + ' ' + item.contact.lastName;
                    item['actions'] = [
                        { name: 'edit', tip: 'Edit Organisation detail' }
                    ];

                    if (item.isActive) {
                        item['actions'].push({ name: 'not_interested', tip: 'De-activate Organisation' });
                    } else {
                        item['actions'].push({ name: 'check_circle', tip: 'Activate Organisation' });
                    }
                })

                this.data = response['data'];
            });
    }

    add() {
        const dialogRef = this.dialog.open(AddManufacturerDialogComponent, {
            width: '680px',
            data: {
                title: 'Add Organisation'
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log('The dialog was closed', result);

            if (result == 'yes') {
                this.loadOrganisations();
            }
        });
    }

    onActionClicked(event) {
        var rec = event.record;
        switch (event.actionName.name) {
            case 'edit':

                var obj = clonedeep(rec);

                obj.confirmPassword = null;
                obj.mfgAddress = rec.address;

                delete obj.contactId;
                if (obj.contact) {
                    delete obj.contact.countryId;
                    delete obj.contact.stateId;
                    delete obj.contact.id;
                }

                Object.assign(obj, obj.contact);

                delete obj.contact;
                delete obj.actions;
                delete obj.createdon;
                delete obj.modifiedon;

                const dialogRef = this.dialog.open(AddManufacturerDialogComponent, {
                    width: '680px',
                    data: {
                        title: 'Edit Organisation',
                        mode: 'edit',
                        data: obj
                    }
                });
                dialogRef.afterClosed().subscribe(result => {
                    console.log('The dialog was closed', result);
                    if (result == 'yes') {
                        this.loadOrganisations();
                    }
                });
                break;
            case "not_interested":
                const dialogRef1 = this.dialog.open(ConfirmationDialogComponent, {
                    width: '450px',
                    data: {
                        message: 'Are you sure you want to de-activate the organisation?'
                    }
                });

                dialogRef1.afterClosed().subscribe(
                    (result) => {
                        if (result == 'yes') {
                            this.miscService.updateOrganisation({ id: rec.id, isActive: false }).subscribe(
                                () => {
                                    this.msgService.showSuccess(this.msgService.orgDeactivate);
                                    this.loadOrganisations();
                                }
                            );
                        }
                    });
                break;
            case "check_circle":
                const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
                    width: '450px',
                    data: {
                        message: 'Are you sure you want to activate the organisation?'
                    }
                });

                dialogRef2.afterClosed().subscribe(
                    (result) => {
                        if (result == 'yes') {
                            this.miscService.updateOrganisation({ id: rec.id, isActive: true }).subscribe(
                                () => {
                                    this.msgService.showSuccess(this.msgService.orgActivate);
                                    this.loadOrganisations();
                                }
                            );
                        }
                    });
                break;
            default:
                console.log('Unhandled action: ', event.actionName);
        }
    }

    styleRow(rec) {
        if (!rec.isActive) {
            return "recalled-row";
        }
    }

    showInActiveOrgTip(rec) {
        if (!rec.isActive) {
            return 'Organisation has been de-activated.';
        }
    }
}